import React, { useState, useEffect, useContext } from "react";
import swal from "sweetalert";
import * as Service from "../../services/Service.js";

// material components
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import makeStyles from '@mui/styles/makeStyles';
import { addDays, subDays } from "date-fns";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { useQuery } from "@tanstack/react-query";
import * as api from "../../actions/api";

import {
  Typography,
  TextField,
  Card,
  CardHeader,
  CardContent,
  Select,
  FormLabel,
  MenuItem,
  FormControl,
  Grid,
  InputLabel,
} from "@mui/material";

import Autocomplete from '@mui/material/Autocomplete';

import { Button } from "reactstrap";

// core components
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar.js";

// Highcharts component
import Highcharts from "highcharts/highstock";
import "highcharts/modules/exporting.js";
import "highcharts/modules/accessibility.js";
import HighchartsReact from "highcharts-react-official"; 

import DefaultFooter from "components/Footers/DefaultFooter";
import { getDefaultQuarterYear,getLabFacilityList,getNationalMOSRangeListByGroup } from "../../services/Common";

import { useTranslation } from "react-i18next";
import {checkLogin, checkUserPermission,getUserActionPermission} from "../../services/CheckUserAccess";

import encryptionService from "../../services/encryptionService";
const ReportPage = (props) => {

  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const currProductGroupId = 12;
  const lan = localStorage.getItem("LangCode");
  const { t, i18n } = useTranslation();
  const menukey = "lab-stock-summary";
  const FacilityId = localStorage.getItem("FacilityId");
  const YearList = JSON.parse(localStorage.getItem("YearList"));
  const QuarterList = JSON.parse(localStorage.getItem("QuarterList"));
  //const Facility_List = JSON.parse(localStorage.getItem("FacilityList"));

/*   let All_Facility_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All Facility"])};
  const FacilityList = [All_Facility_label].concat(getLabFacilityList());
 // const FacilityList = [All_Facility_label].concat(Facility_List); 
  const bFacilitySelected = localStorage.getItem("bFacilitySelected"); */

  // const MosTypelist = JSON.parse(localStorage.getItem("MosTypelist"));


  
              
/* =============Start Department, Zone, Commune, Facility Dipendency=============  */
const bFacilitySelected = localStorage.getItem("bFacilitySelected");
const UserInfo = encryptionService.decryptUserInfo();
const defaultRegionId = UserInfo == 0 ? 0 : UserInfo[0].RegionId;
const defaultZoneId = UserInfo == 0 ? 0 : UserInfo[0].ZoneId;
const defaultDistrictId = UserInfo == 0 ? 0 : UserInfo[0].DistrictId;

const objAll = { id: "0", name: t(DispensingLanguage[lan][menukey]["All"]) };

const Regionlist = JSON.parse(localStorage.getItem("Regionlist"));
Regionlist.unshift(objAll);
const [currRegionId, setcurrRegionId] = useState(
  bFacilitySelected == 1 ? defaultRegionId : 0
);
const [chosenValuesRegion, setChosenValuesRegion] = useState(
  bFacilitySelected == 1
    ? (Regionlist.find((list) => list.id == defaultRegionId) ?? null)
    : objAll
);

let TempZSList = useState([]);
const [ZoneList, setZoneListLocal] = useState(TempZSList);
//const [currZoneId, setcurrZoneId] = useState(0);
const [currZoneId, setcurrZoneId] = useState(
  bFacilitySelected == 1 ? defaultZoneId : 0
);
const [chosenValuesZone, setChosenValuesZone] = useState({});

let TempCommuneList = useState([]);
const [CommuneList, setCommuneListLocal] = useState(TempCommuneList);
//const [currCommuneId, setcurrCommuneId] = useState(0);
const [currCommuneId, setcurrCommuneId] = useState(
  bFacilitySelected == 1 ? defaultDistrictId : 0
);
/* const [chosenValuesDistrict, setChosenValuesDistrict] = useState({
  "DistrictId": objAll
}); */

const [chosenValuesDistrict, setChosenValuesDistrict] = useState({});

let TempFacilityList = useState([]);
const [FacilityList, setFacilityListLocal] = useState(TempFacilityList);
const [currFacilityId, setcurrFacilityId] = useState(
  bFacilitySelected == 1 ? FacilityId : 0
);
const [chosenValuesFacility, setChosenValuesFacility] = useState({});

React.useEffect(() => {
  cZoneList();
}, [currRegionId]);

React.useEffect(() => {
  cCommuneList();
}, [currRegionId, currZoneId]);

React.useEffect(() => {
  cFacilityList();
}, [currRegionId, currZoneId, currCommuneId]);

//====== Start Choosen Dropdown===========

const handleChangeChoosenRegion = (name, valueobj, value) => {
  /*  let chosenValuesDataRegion = { ...chosenValuesRegion};
chosenValuesDataRegion[name] = valueobj; */
  setChosenValuesRegion(valueobj);

  /* setFirstLoad(true); */
  //setLoading(false);
  setcurrRegionId(value);

  setcurrZoneId(0);
  setcurrCommuneId(0);
  setcurrFacilityId(0);

  setChosenValuesZone(objAll);
  setChosenValuesDistrict(objAll);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenZone = (name, valueobj, value) => {
  /* let chosenValuesDataZone = { ...chosenValuesZone};
chosenValuesDataZone[name] = valueobj; */
  setChosenValuesZone(valueobj);

  /* setFirstLoad(true); */
  //setLoading(false);
  setcurrZoneId(value);

  setcurrCommuneId(0);
  setcurrFacilityId(0);

  setChosenValuesDistrict(objAll);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenDistrict = (name, valueobj, value) => {
  /* let chosenValuesDataDistrict = { ...chosenValuesDistrict};
chosenValuesDataDistrict[name] = valueobj; */
  setChosenValuesDistrict(valueobj);

  //setLoading(false);
  setcurrCommuneId(value);

  setcurrFacilityId(0);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenFacility = (name, valueobj, value) => {
  /*  let chosenValuesDataFacility = { ...chosenValuesFacility};
chosenValuesDataFacility[name] = valueobj; */
  setChosenValuesFacility(valueobj);

  //setLoading(false);
  setcurrFacilityId(value);
};

//====== End Choosen Dropdown===========

const cZoneList = () => {
  let ZoneListParam = {
    action: "Zonelist",
    RegionId: currRegionId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", ZoneListParam)
    .then((res) => {
      let All_Zone_label = objAll;
      const Zone_List = [All_Zone_label].concat(res.datalist);
      setZoneListLocal(Zone_List);

      let defaultZoneDDD =
        (Zone_List.find((list) => list.id == currZoneId) ?? null);
      /* let chosenValuesDataZoneAA = {};
      chosenValuesDataZoneAA["ZoneId"] = defaultZoneDDD; */
      setChosenValuesZone(defaultZoneDDD);
    })
    .catch((err) => {});
};

const cCommuneList = () => {
  let CommuneListParam = {
    action: "Communelist",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", CommuneListParam)
    .then((res) => {
      let All_Commune_label = objAll;
      const Commune_List = [All_Commune_label].concat(res.datalist);
      setCommuneListLocal(Commune_List);

      let defaultCommune =
        (Commune_List.find((list) => list.id == currCommuneId) ?? null);
      /* let chosenValuesDataCommune = {};
    chosenValuesDataCommune["DistrictId"] = defaultCommune; */
      setChosenValuesDistrict(defaultCommune);
    })
    .catch((err) => {});
};

const cFacilityList = () => {
  let FacilityListParam = {
    action: "LABFacilityListByDepartmentZoneCommune",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    DistrictId: currCommuneId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", FacilityListParam)
    .then((res) => {
      let All_Facility_label = objAll;
      const Facility_List = [All_Facility_label].concat(res.datalist);
      setFacilityListLocal(Facility_List);
      let defaultFacilityDDD =
        (Facility_List.find(
            (facilitylist) => facilitylist.id == currFacilityId
          ) ?? null);

      /* let chosenValuesDataFacilityAA = {};
      chosenValuesDataFacilityAA["FacilityId"] = defaultFacilityDDD; */

      setChosenValuesFacility(defaultFacilityDDD);
    })
    .catch((err) => {});
};

/* =============End Department, Zone, Commune, Facility Dipendency=============  */
 
 


  const classes = useStyles();

  const [pickerData, setPickerData] = useState([{
      startDate: subDays(new Date(), 29),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [isLoadingDashboard, setLoading] = useState(true);

  const [currYearId, setCurrYearId] = useState(
    getDefaultQuarterYear().defaultYear
  );
  const [currMonthId, setCurrMonthId] = useState(
    getDefaultQuarterYear().defaultMonthId
  );

  /* const [currFacilityId, setCurrFacilityId] = useState(bFacilitySelected == 1 ? FacilityId: 0); */

  const handleYearChange = (event) => {
    setCurrYearId(event.target.value);
  };

  const handleMonthChange = (event) => {
    setCurrMonthId(event.target.value);
  };

/*   const handleFacilityChange = (event) => {
    setCurrFacilityId(event.target.value);
  }; */

/*   const handleFacilityChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }

    setCurrFacilityId(rowId);
 };
 */
  const [nationalStockCategory, setNationalStockCategory] = useState([]);
  const [nationalStockData, setNationalStockData] = useState([]);
  const [nationalStockDateRange, setnationalStockDateRange] = useState([]);

  const option_National_Stock_Summary = () => {
    let National_Stock_Summary = {
      chart: {
        type: "bar",
        borderColor: "#C3DDEC",
        height: 600,
        exporting:{
          enabled: true
      }, 
         //   borderWidth: 1,
         //   plotBorderWidth: 1,
            margin: [50, 50, 50, 300],

      },
      title: {
        text:
          t(DispensingLanguage[lan][menukey]["Summary Report of"]) +
          " " +
          nationalStockDateRange,
      },
      xAxis: {
        categories: nationalStockCategory,
       
      },
      yAxis: { 
        min: 0,
        max:36,
        title: {
          text: t(DispensingLanguage[lan][menukey]["Month of Stock (MOS)"]),
          align: 'middle'
        },
        labels: {
          overflow: 'justify'
         }
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        valueSuffix: " month(s)",
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            crop: true,
            formatter: function () {
              return this.y;
            },
          },
        },
      },
      series: [
        {
          name: nationalStockDateRange, 
          data: nationalStockData  ,
        },
      ],
    };

    return National_Stock_Summary;
  };

  let params = {
    action: "getLabStockSummaryChart",
    menukey: menukey,
    RegionId: currRegionId,
    ZoneId: currZoneId,
    CommuneId: currCommuneId,
    FacilityId: currFacilityId,
    Month: currMonthId,
    Year: currYearId,
  };
  const { data:stockDetailData } = useQuery([params], api.getLabStockSummaryChart, {
    onSuccess: (data) => {

      setNationalStockCategory(data.data.NationalStockCategory.category);
      setnationalStockDateRange(data.data.NationalStockCategory.date_range);

      let Ndata = [];

      for (let i = 0; i < data.data.NationalStockCategory.data.length; i++) {
        let newdata = {};
        newdata.y = data.data.NationalStockCategory.data[i].y;
        newdata.color = data.data.NationalStockCategory.data[i].color;

        Ndata.push(newdata);
      }
      setNationalStockData(Ndata);
    },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
  });

  let params1 = {
    action: "getLabStockSummaryTable",
    menukey: menukey,
    RegionId: currRegionId,
    ZoneId: currZoneId,
    CommuneId: currCommuneId,
    FacilityId: currFacilityId,
    Month: currMonthId,
    Year: currYearId,
  };
  const [dataItems, setDataItems] = useState([]);
  const { refetch } = useQuery([params1], api.getLabStockSummaryTable, {
    onSuccess: (data) => {
      setDataItems(data);
	},
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
  });

  useEffect(() => {
    if (currYearId > 0 && currMonthId > 0) {
      // getConsumptionTrendsTopFiveProducts.refetch();
    }
  }, [currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId]);

  const [RedirectLogin, setRedirectLogin] = React.useState(true);
  const [hasUserPermission, setHasUserPermission] = React.useState(false);

  /* const checkLogin = () => {
    let token = sessionStorage.getItem("token");
    if (!token) {
      swal({
        title: "Oops!",
        text: 'token expired. Please login again',
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) { 
          window.location.href = process.env.REACT_APP_BASE_NAME+`/login`;
          sessionStorage.clear();
        }
      });
    }
  }; */

  if(RedirectLogin){
    setHasUserPermission(checkUserPermission(menukey));// To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }

  React.useEffect(() => {
    // checkLogin();
  }, []);

  const handleDatePicker = (e) => {};

  const columns = [
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#."]),
      formatter: "rownum",
      width: 40,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Code"]),
      field: "ItemCode",
      width: 150,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Name"]),
      field: "ItemName",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Closing Balance"]),
      field: "ClosingStock",
      width: 150,
      hozAlign: "right",
      headerHozAlign: "right",
      formatter: "money",
      formatterParams:{ thousand:",",  precision:false }
    },
    {
      title: t(DispensingLanguage[lan][menukey]["AMC"]),
      field: "AMC",
      width: 150,
      hozAlign: "right",
      headerHozAlign: "right",
      formatter: "money",
      formatterParams:{ thousand:",",  precision:false }
    },
    {
      title: t(DispensingLanguage[lan][menukey]["MOS"]),
      field: "MOS",
      width: 150,
      hozAlign: "right",
      headerHozAlign: "right",
      formatter: "money",
    }
  ];

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let currFacilityName = (FacilityList.find((Facility_List) => Facility_List.id == currFacilityId) ?? null).name;
    let currDepartmentName = (Regionlist.find((List) => List.id == currRegionId) ?? null).name;
    let currZoneName = (ZoneList.find((List) => List.id == currZoneId) ?? null).name;
    let currCommuneName = (CommuneList.find((List) => List.id == currCommuneId) ?? null).name;


    window.open(
      finalUrl +
        "?action=LabStockSummaryExcelExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") + 
        "&TimeStamp=" + Date.now() + 
        "&Month=" + currMonthId +
        "&Year=" + currYearId +
        "&RegionId=" + currRegionId +
        "&ZoneId=" + currZoneId +
        "&CommuneId=" + currCommuneId +
        "&FacilityId=" + currFacilityId +
        "&FacilityName=" + currFacilityName +
        "&DepartmentName=" + currDepartmentName +
        "&ZoneName=" + currZoneName +
        "&CommuneName=" + currCommuneName
    );
  };
  /* =====End of Excel Export Code==== */

  return (
    hasUserPermission && (
        <>
          <AfterLoginNavbar {...props} />

          <div
            className="section signup-top-padding"
            style={{
              backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
              backgroundSize: "cover",
              backgroundPosition: "top center",
              minHeight: "753px",
            }}
          >
            <div className="dashboard-pannel">
              <div className="d-flex justify-product mb-1">
                <div className="sw_page_heading">
                  <div className="sw_heading_title">
                    {t(DispensingLanguage[lan][menukey]["Lab Stock Summary"])}
                  </div>
                </div>
              </div>

              {/* start of filter */}
              <Card className="sw_card sw_filter_card">
                <CardContent className="sw_filterCardContent">
                  <Grid container spacing={1}>
                    <Grid item xs={1} sm={1}>
                      <FormControl variant="standard" className={classes.fullWidth}>
                      <InputLabel id="demo-simple-select-helper-label">
                        {DispensingLanguage[lan][menukey]["Year"]}
                      </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="YearList"
                          name="YearList"
                          value={currYearId}
                          onChange={handleYearChange}
                          fullWidth
                        label={DispensingLanguage[lan][menukey]["Year"]}>
                          {YearList.map((item, index) => {
                            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <FormControl variant="standard" className={classes.fullWidth}>
                      <InputLabel id="demo-simple-select-helper-label">
                        {DispensingLanguage[lan][menukey]["Quarter"]}
                      </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="MonthList"
                          name="MonthList"
                          value={currMonthId}
                          onChange={handleMonthChange}
                          fullWidth
                        label={DispensingLanguage[lan][menukey]["Quarter"]}>
                          {QuarterList.map((item, index) => {
                            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    
                    <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="RegionId"
                            options={Regionlist}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenRegion(
                                "RegionId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesRegion}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={
                                  DispensingLanguage[lan][menukey]["Department"]
                                }
                                variant="standard"
                                id="RegionId"
                                name="RegionId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="ZoneId"
                            options={ZoneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenZone(
                                "ZoneId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesZone}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["ZS"]}
                                variant="standard"
                                id="ZoneId"
                                name="ZoneId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="DistrictId"
                            options={CommuneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenDistrict(
                                "DistrictId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesDistrict}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Commune"]}
                                variant="standard"
                                id="DistrictId"
                                name="DistrictId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={3} sm={3}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="FacilityId"
                            options={FacilityList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenFacility(
                                "FacilityId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesFacility}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Facility"]}
                                variant="standard"
                                id="FacilityId"
                                name="FacilityId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                    

                    {/* <Grid item xs={3} sm={3}>
                      <FormControl className={classes.fullWidth}>
                       
                    <Autocomplete
                          autoHighlight
                          className="sw_chosen_filter"
                          id="FacilityList"
                          disableClearable
                          options={FacilityList}
                          onChange={(event, newValue) => handleFacilityChange(event, newValue)}
                          getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                          defaultValue={FacilityList[FacilityList.findIndex(facilitylist => facilitylist.id == currFacilityId)]}
                          renderOption={(props, option) => (
                            <li {...props} key={option.id ?? option.name}>
                              <Typography className="sw_fontSize">{option.name}</Typography>
                            </li>
                          )}
                          
                          renderInput={(params) => (
                          <TextField
                            {...params}
                            // label={DispensingLanguage[lan][menukey]["All Facility"]}
                            variant="standard"
                            hiddenLabel
                          />
                          )}
                        />

                      </FormControl>
                    </Grid> */}

                    <Grid item xs={6} sm={6}></Grid>
                  </Grid>
                </CardContent>
              </Card>
              {/* end of filter */}

              {/* new row */}
              <div className="row">
                <div className="col-md-12 mb-4">
                  <Card className="sw_card">
                    <CardHeader
                      title={t(
                        DispensingLanguage[lan][menukey][
                          "Stock Summary (Month of Stock = MOS)"
                        ]
                      )}
                    />
                    <CardContent>
                      <div className="row">
                        <div className="col-md-12">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={option_National_Stock_Summary()}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mylegend_area">
                            {getNationalMOSRangeListByGroup(currProductGroupId).map((item, index) => {
                              return (
                                <div key={index} className="my_legend">
                                  <div
                                    className="mylegend_color"
                                    style={{ background: item.ColorCode }}
                                  ></div>
                                  <div className="mylegend_label">{item.name}</div>
                                  <div className="mylegend_val">
                                    {item.MosLabel}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
              {/* end row */}

              {/* new row */}
              <div className="row">
                <div className="col-md-12">
                  <Card className="sw_card">
                    <CardHeader
                      title={t(DispensingLanguage[lan][menukey]["Stock Summary"])}

                      action={
                        <div className="float-end sw_btn_control">
                        <Button
                          color="info"
                          className="me-2 sw_icons"
                          onClick={() => PrintPDFExcelExportFunction("print")}
                        >
                          <i className="fas fa-print"></i>
                        </Button>

                        <Button
                          color="info"
                          className="me-2 sw_icons"
                          onClick={() => PrintPDFExcelExportFunction("excel")}
                        >
                          <i className="far fa-file-excel"></i>
                        </Button>
                      </div>
                      }
                    />

                    <CardContent>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="uniqueName">
                            <ReactTabulator
                              columns={columns}
                              data={dataItems}
                              layout={"fitColumns"}
                            />
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
              {/* end row */}
            </div>
          </div>
        </>)
  );
};

export default ReportPage;

const useStyles = makeStyles({
  root: {
    width: "20%",
    margin: "0 1rem",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  cardDiv: {
    display: "flex",
  },
  fullWidth: {
    width: "100%",
  },
});
